import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

// import Home from '../views/home/home.vue'
const Home = () => import('../views/home/Home.vue')
const Login = () => import('../views/login/Login.vue')

const HomePage = () => import('../views/homePage/homePage.vue')

const Project = () => import('../views/model/project/project.vue')
const Configuration = () => import('../views/model/configuration/configuration.vue')

const DeviceList = () => import('../views/device/deviceList/deviceList.vue')
const DeviceDetails = () => import('../views/device/deviceList/deviceDetails/deviceDetails.vue')
const HistoricalData = () => import('../views/device/historicalData/historicalData.vue')

const AlarmRules = () => import('../views/alarms/alarmRules/alarmRules.vue')
const AlarmHistory = () => import('../views/alarms/alarmHistory/alarmHistory.vue')

const Overview = () => import('../views/energy/overview/overview.vue')
const ProEnergy = () => import('../views/energy/projectEnergy/projectEnergy.vue')
const EnergyHistory = () => import('../views/energy/energyHistory/energyHistory.vue')



const routes = [
  {
    path: '/',
    redirect: 'login',
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
    redirect: { path: '/homePage' },
    children: [
      {
        path: '/homePage',
        name: 'homePage',
        component: HomePage,
        meta:{
          name:'首页',
        }
      },{
        path: '/project',
        name: 'project',
        component: Project,
        meta:{
          name:'项目工况',
        }
      },{
        path: '/configuration',
        name: 'configuration',
        component: Configuration,
        meta:{
          name:'组态监控',
        }
      },{
        path: '/deviceList',
        name: 'deviceList',
        component: DeviceList,
        meta:{
          name:'设备列表',
        }
      },{
        path: '/deviceDetails',
        name: 'deviceDetails',
        component: DeviceDetails,
        meta:{
          name:'设备详情',
        }
      },{
        path: '/historicalData',
        name: 'historicalData',
        component: HistoricalData,
        meta:{
          name:'历史数据',
        }
      },{
        path: '/alarmRules',
        name: 'alarmRules',
        component: AlarmRules,
        meta:{
          name:'报警规则',
        }
      },{
        path: '/alarmHistory',
        name: 'alarmHistory',
        component: AlarmHistory,
        meta:{
          name:'报警历史',
        }
      },{
        path: '/overview',
        name: 'overview',
        component: Overview,
        meta:{
          name:'能耗概览',
        }
      },{
        path: '/proEnergy',
        name: 'proEnergy',
        component: ProEnergy,
        meta:{
          name:'项目能耗',
        }
      },{
        path: '/energyHistory',
        name: 'energyHistory',
        component: EnergyHistory,
        meta:{
          name:'能耗明细',
        }
      }
    ]
  },
]










const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})



export default router
